import Icon from 'veui/components/Icon'
import { IconUserMobile } from 'dls-icons-vue'

Icon.register('user-mobile', IconUserMobile)
